import { createFileRoute } from '@tanstack/react-router';
import { SnapFormPage } from '@/pages/SnapFormPage';

export const Route = createFileRoute('/$location')({
  component: SnapFormPage,
});
